import React from 'react'

interface ArrowIconProps {
  className?: string
  stroke?: string
  direction?: 'left' | 'right'
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({
  className = 'size-4',
  stroke = 'currentColor',
  direction = 'right',
}) => (
  <svg
    className={`${className}${direction === 'left' ? ' rotate-180' : ''}`}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 8H13M13 8L9 4M13 8L9 12"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
